import { Injectable } from '@angular/core';
import { Rppk15Day, Rppk15GateRow, Rppk15TableResult, Rppk15Totals } from '../../models/report/rppk15.model';

@Injectable({ providedIn: 'root' })
export class MapperRppk15Service {
  mapTable(res: unknown): Rppk15TableResult {
    const raw = (res ?? {}) as Record<string, unknown>;
    const days = (raw['days'] ?? raw['Days'] ?? []) as unknown[];
    return {
      siteName: String(raw['siteName'] ?? raw['SiteName'] ?? ''),
      siteAddress: String(raw['siteAddress'] ?? raw['SiteAddress'] ?? ''),
      siteTaxId: String(raw['siteTaxId'] ?? raw['SiteTaxId'] ?? ''),
      startDate: (raw['startDate'] ?? raw['StartDate'] ?? null) as string | null,
      endDate: (raw['endDate'] ?? raw['EndDate'] ?? null) as string | null,
      days: days.map((d) => this.mapDay(d)),
      totals: this.mapTotals(raw['totals'] ?? raw['Totals'] ?? {}),
    };
  }

  private mapDay(dto: unknown): Rppk15Day {
    const d = (dto ?? {}) as Record<string, unknown>;
    const gates = (d['gates'] ?? d['Gates'] ?? []) as unknown[];
    return {
      date: (d['date'] ?? d['Date'] ?? null) as string | null,
      siteRowLabel: String(d['siteRowLabel'] ?? d['SiteRowLabel'] ?? ''),
      gates: gates.map((g) => this.mapGate(g)),
      entryByHour: this.mapHourArray(d['entryByHour'] ?? d['EntryByHour']),
      totalEntry: Number(d['totalEntry'] ?? d['TotalEntry'] ?? 0),
    };
  }

  private mapGate(dto: unknown): Rppk15GateRow {
    const g = (dto ?? {}) as Record<string, unknown>;
    return {
      gateId: Number(g['gateId'] ?? g['GateId'] ?? 0),
      gateName: String(g['gateName'] ?? g['GateName'] ?? ''),
      entryByHour: this.mapHourArray(g['entryByHour'] ?? g['EntryByHour']),
      totalEntry: Number(g['totalEntry'] ?? g['TotalEntry'] ?? 0),
    };
  }

  private mapTotals(dto: unknown): Rppk15Totals {
    const t = (dto ?? {}) as Record<string, unknown>;
    return {
      dayCount: Number(t['dayCount'] ?? t['DayCount'] ?? 0),
      sumEntry: Number(t['sumEntry'] ?? t['SumEntry'] ?? 0),
    };
  }

  private mapHourArray(value: unknown): number[] {
    const src = Array.isArray(value) ? value : [];
    const result = new Array<number>(24).fill(0);
    for (let i = 0; i < 24; i++) {
      result[i] = Number(src[i] ?? 0);
    }
    return result;
  }
}
